// extracted by mini-css-extract-plugin
module.exports = {"donateBtn":"jgp-1bSdE","ctaWrapper":"jgp-1ZJHE"};